import { Navigate, Outlet, RouteObject, useLocation } from 'react-router-dom';
import React from 'react';
import useAuthStore from './stores/auth.store';
import SignInPage from './pages/sign-in-page/SignInPage';
import DashboardPage from './pages/dashboard-page/DashboardPage';
import LocationPage from './pages/location-page/LocationPage';
import InstallationLocationPage from './pages/installation-location-page/InstallationLocationPage';
import InstallationLocationDetailPage from './pages/installation-location-detail-page/InstallationLocationDetailPage';
import DevicePage from './pages/device-page/DevicePage';
import AlarmPage from './pages/alarm-page/AlarmPage';
import DeviceHistoryPage from './pages/device-history-page/DeviceHistoryPage';
import InstallationDetailPage from './pages/installation-detail-page/InstallationDetailPage';
import SensorsInstallationPage from './pages/installation-detail-page/sensors-installation-page/SensorsInstallationPage';
import GraphicInstallationPage from './pages/installation-detail-page/graphic-installation-page/GraphicInstallationPage';
import SummaryInstallationPage from './pages/installation-detail-page/summary-installation-page/SummaryInstallationPage';
import UsersPage from './pages/users-page/UsersPage';
import TenantPage from './pages/tenant-page/TenantPage';
import AccountPage from './pages/account-page/AccountPage';
import ResetPasswordPage from './pages/reset-password-page/ResetPasswordPage';

export const defaultPath = '/';
export const signInPath = '/sign-in';
export const restorePasswordPath = '/reset-password';
export const dashboardPath = 'dashboard';
export const locationInstallationPath = 'location-installation';
export const locationInstallationDetailPath = 'location-installation';
export const locationPath = 'location';
export const alarmPath = 'alarm';
export const devicePath = 'device';
export const devicesPath = 'devices';
export const installationDetailPath = 'installation';
export const usersPath = 'users';
export const tenantsPath = 'tenants';
export const accountPath = 'account';

export const deviceHistoryPath = 'history';

export const summaryInstallationPath = 'summary';
export const sensorInstallationPath = 'sensors';
export const graphicsInstallationPath = 'graphs';

function ProtectedRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();
  if (!isAuthenticated) return <Navigate to={signInPath} state={{ from: location }} replace />;
  return <Outlet />;
}

function TemporaryPasswordRoute() {
  const location = useLocation();
  const state = location.state as { email?: string; temporaryPassword?: string } | null;
  if (!state?.email || !state?.temporaryPassword) return <Navigate to={signInPath} replace />;
  return <Outlet />;
}

const routes: RouteObject[] = [
  {
    path: defaultPath,
    children: [
      {
        path: signInPath,
        element: <SignInPage />,
      },

      {
        path: restorePasswordPath,
        element: <TemporaryPasswordRoute />,
        children: [{ index: true, element: <ResetPasswordPage /> }],
      },
      {
        path: `${dashboardPath}`,
        element: <ProtectedRoute />,
        children: [
          {
            path: '',
            element: <DashboardPage />,
            children: [
              {
                path: devicesPath,
                element: <DevicePage />,
              },
              {
                path: locationInstallationPath,
                element: <InstallationLocationPage />,
              },
              {
                path: locationPath,
                element: <LocationPage />,
              },
              {
                path: alarmPath,
                element: <AlarmPage />,
              },
              {
                path: usersPath,
                element: <UsersPage />,
              },
              {
                path: tenantsPath,
                element: <TenantPage />,
              },
              {
                path: accountPath,
                element: <AccountPage />,
              },
              {
                path: `${locationInstallationDetailPath}/:installationLocationUuid`,
                element: <InstallationLocationDetailPage />,
              },
              {
                path: `${locationInstallationDetailPath}/:installationLocationUuid/${installationDetailPath}/:installationUuid`,
                element: <InstallationDetailPage />,
                children: [
                  {
                    path: summaryInstallationPath,
                    element: <SummaryInstallationPage />,
                  },
                  {
                    path: sensorInstallationPath,
                    element: <SensorsInstallationPage />,
                  },
                  {
                    path: graphicsInstallationPath,
                    element: <GraphicInstallationPage />,
                  },
                ],
              },
              {
                path: `${devicePath}/:deviceUuid/${deviceHistoryPath}`,
                element: <DeviceHistoryPage />,
              },
            ],
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
];

export default routes;
